module.exports = {
          srcSet: __webpack_public_path__ + "public/8b1b81a7a3687f6e159b4941f0bbfadb-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/8b1b81a7a3687f6e159b4941f0bbfadb-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/8b1b81a7a3687f6e159b4941f0bbfadb-80.png",
          toString:function(){return __webpack_public_path__ + "public/8b1b81a7a3687f6e159b4941f0bbfadb-80.png"},
          
          width: 80,
          height: 80
        }